import StudentIrosPage from "./StudentIrosPage";

export default StudentIrosPage